<template>
  <button
    v-bind="{ ...$attrs, disabled: disabled || loading, type }"
    :class="['t-button', { selected, outline, block, square }]"
    @click="$emit('click', $event)"
  >
    <t-spinner v-if="loading" small></t-spinner>
    <slot></slot>
  </button>
</template>

<script>
import { useColorsStore } from 'Store/colors'

export default {
  name: 'ThemeButton',

  setup() {
    const colorsStore = useColorsStore()

    return { colorsStore }
  },

  props: {
    type: {
      type: String,
      default: 'button'
    },
    block: Boolean,
    loading: Boolean,
    disabled: Boolean,
    outline: Boolean,
    square: Boolean,
    selected: Boolean
  }
}
</script>
